import {BASE_CRM_URL} from "../../constants/index";

const BASE_API_PATH = /clientApi/;

function getURL(path) {
  return BASE_CRM_URL + BASE_API_PATH + path;
}

export const loginURL = getURL('auth/login');
export const statementURL = getURL('contact/{contact_id}/statement/');
export const logoutURL = getURL('auth/logout');
export const resetPasswordURL = getURL('user/resetPassword');
export const changePasswordURL = getURL('user/changePassword');
export const verifyPasswordTokenURL = getURL('user/verifyPasswordToken');
export const helpLoginURL = getURL('user/passwordHelp');
export const nextPaymentURL = getURL('contact/{contact_id}/nextPayment/');
export const autoplayVideoURL = getURL('contact/{contact_id}/autoplayVideo/');
export const trackVideoPlaybackURL = getURL('contact/{contact_id}/trackVideoPlayback/');
export const overviewAccountsURL = getURL('contact/{contact_id}/overview/accounts/');
export const contactDataURL = getURL('contact/{contact_id}/');
export const budgetURL = getURL('contact/{contact_id}/budget?is_crm=');
export const budgetMonthsURL = getURL('contact/{contact_id}/budgetMonths/');
export const unsubscribeEmailsURL = getURL('user/{username}/unsubscribe/email/');
export const documentsURL = getURL('documents');
export const documentDownloadURL = getURL('documents/{file_id}/');
export const trackingURL = BASE_CRM_URL + '/shared/trackHit';
export const validateImpersonationURL = getURL('auth/validateImpersonation/{contact_id}/');
export const availabilityHoursURL = getURL('team/{team_id}/info/');
export const scheduleAppointmentURL = getURL('team/{team_id}/scheduleAppointment/');
export const scheduleAppointmentMeURL = getURL('team/{team_id}/scheduleAppointment/me/');
export const contactUsURL = getURL('user/contactUs');
export const supportInfoURL = getURL('supportInfo');
export const notEnrolledDebtURL = getURL('contact/{contact_id}/overview/accounts/get_not_enrolled/');
export const enrollDebtURL = getURL('contact/{contact_id}/overview/accounts/enroll/');
export const alertsURL = getURL('contact/{contact_id}/alerts');
export const alertDismissURL = getURL('contact/{alert_id}/alertDismiss/');
// export const videosURL = getURL('videos');



// WEBPACK FOOTER //
// ./src/shared/urls/clientapi.js